import styled from 'styled-components';
import { BaseImgProps } from '@oberoninternal/travelbase-website/dist/components/Img';
import Hero from '@oberoninternal/travelbase-website/dist/components/designsystem/Hero';
import focalPointToPosition from '../utils/focalPointToPosition';

export interface HeroProps extends BaseImgProps {
    ratio: number;
    mobileRatio: number;
    focalPoint?: number[];
}

export default styled(Hero)<HeroProps>`
    position: relative;

    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.m}) {
        &:before {
            padding-top: ${({ mobileRatio }) => Math.round(mobileRatio * 100)}%;
        }
    }

    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.xs}) {
        img {
            padding-bottom: 1.6rem;
        }
    }

    img {
        object-position: ${({ focalPoint }) => focalPointToPosition(focalPoint)};
    }
`;
